import { useMemo } from 'react';

import { format, subDays } from 'date-fns';

import { IconDate } from '@components/icons/date';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';

export const useMessageCreatedFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'date',
      label: t('messages.filters.date.title'),
      icon: <IconDate />,
      type: 'date',
      toExternalQuery: (filter) => {
        const now = new Date();
        const prefix = 'created__date';

        switch (filter.comparer) {
          case 'today': {
            const selectedDay = new Date();
            return { [prefix]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'yesterday': {
            const selectedDay = subDays(now, 1);
            return { [prefix]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'gt': {
            const selectedDay = subDays(now, Number(filter.value));
            return { [`${prefix}__lt`]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'eq': {
            const selectedDay = subDays(now, Number(filter.value));
            return { [prefix]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'lt': {
            const selectedDay = subDays(now, Number(filter.value));
            return { [`${prefix}__gte`]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'after': {
            const selectedDay = new Date(filter.value as string);
            return { [`${prefix}__gte`]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'before': {
            const selectedDay = new Date(filter.value as string);
            return { [`${prefix}__lt`]: format(selectedDay, 'yyyy-MM-dd') };
          }
          case 'on': {
            const selectedDay = new Date(filter.value as string);
            return { [prefix]: format(selectedDay, 'yyyy-MM-dd') };
          }
          default:
            return {};
        }
      },
    }),
    [t],
  );
};
